import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges, // 1. Import ViewChild
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { ValidationMessageService } from "@app/shared/services/validation-message/validation-message.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CallsLogsService } from "./services/calls-logs.service";
import { ToastrMessageService } from "@app/shared/services/toastr-message/toastr-message.service";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "crm-calls-logs",
  templateUrl: "./calls-logs.component.html",
  styleUrls: ["./calls-logs.component.scss"],
})
export class CallsLogsComponent implements OnInit,OnChanges {
  @Input() type: string = "add";
  @Input() buttonName: string = "Add Call";
  @Input() modalTitle: string;
  @Input() formValid: boolean;
  @Input() organizationId: any;
  @Input() company_id: any;
  @Input() call_log_id: any;
  @Input() veiwType: any = 'hide';


  @Output() onSubmit = new EventEmitter();
  @Output() value = new EventEmitter<any>();
  callLogForm: FormGroup;
  @ViewChild("ModalRef", { static: false }) ModalRef: TemplateRef<any>;
  modalRef: BsModalRef;
  @Output() leadCalllogDetails = new EventEmitter<any>();
  config = {
    backdrop: true,
    ignoreBackdropClick: true,
  };

  constructor(
    private modalService: BsModalService,
    private validationMessageService: ValidationMessageService,
    private cdr: ChangeDetectorRef,
    private _CallsLogsService: CallsLogsService,
    private formBuilder: FormBuilder,
    private toastrMessage: ToastrMessageService,
  ) {
  }
  ngOnInit() {
    this.buildCallLogForm();

    if (this.veiwType !== 'hide') {
      this.getCallLogList();
      this.getContactList();
    }
    if (this.call_log_id != null && this.type == 'edit') {
      this.callLogDetail();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['organizationId'].firstChange) ||
      (changes['company_id'].firstChange)
    ) {
      console.log('Org or Company changed → reload files');

      this._CallsLogsService.clearCallsCache();
    }
  }

  openModal(template: TemplateRef<any>, type?: any, dataItem?: any) {

    console.log("openModal :", this.type, this.veiwType, this.call_log_id, this.organizationId, this.company_id)
    console.log("dataItem :", dataItem)
    if (type === 'add') {
      this.type = 'add'
      this.resetCallLogForm()
      this.modalRef = this.modalService.show(template, this.config);
    } else if (type === 'edit') {
      this.type = 'edit'
      this.call_log_id = dataItem.call_log_id
      this.callLogDetail()
      this.modalRef = this.modalService.show(template, this.config);
    } else {
      this.type = 'add'
      this.modalRef = this.modalService.show(template, this.config);
    }

  }

  public show() {
    this.openModal(this.ModalRef);
  }

  onCancel(): void {
    // to hide the red border on form field
    this.validationMessageService.formSubmitted = false;
    this.modalRef.hide();
  }
  //call log start 
  buildCallLogForm() {
    this.callLogForm = this.formBuilder.group({
      call_type: ['OUTGOING', [Validators.required]],
      call_status: ['SCHEDULED'],
      call_result: ['CONTACTED'],
      notes: ['', [Validators.required]],
      contact_id: [''],
      call_start_datetime: [this.formatDateTime(new Date())],
      call_end_datetime: [this.formatDateTime(new Date())],
      reminder_datetime: [this.formatDateTime(new Date())],
      is_reminder_set: [0],
    });
  }
  getCallLogList() {
    const payload = {
      company_id: this.company_id,
      page: 1,
      limit: 20,
      sort: "DESC",
      sort_field: "call_log_id",
      fields: [
        {
          field: "string",
          operator: "contains or matches",
          value: "string"
        }
      ]
    }
    console.log("payload;", payload, this.organizationId)
    this._CallsLogsService.getCallLogList(payload, this.organizationId).subscribe(
      (response) => {
        if (response.success === true || response.success === 'true') {
          this.leadCalllogDetails = response.data;

          this.cdr.detectChanges()
          if (this.type == 'edit') {
            console.log("this.", this.type)
            this.value.emit(response.data)
          } else if (this.type == 'add') {
            this.leadCalllogDetails.emit(response.data);
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  //date format converter
  formatDateTime(dateTime: any): string | null {
    if (!dateTime) return null;

    const date = new Date(dateTime);

    const pad = (n: number) => n < 10 ? '0' + n : n;

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }
  submitCallLog(): void {
    const reminderValue = this.callLogForm.get('is_reminder_set').value;
    this.callLogForm.get('is_reminder_set').setValue(reminderValue ? 1 : 0);
    if (this.callLogForm.invalid) {
      return;
    }
    //set the date format
    const call_start_datetime = this.callLogForm.get('call_start_datetime').value
    const call_end_datetime = this.callLogForm.get('call_end_datetime').value
    const reminder_datetime = this.callLogForm.get('reminder_datetime').value
    this.callLogForm.patchValue({
      call_start_datetime: this.formatDateTime(call_start_datetime),
      call_end_datetime: this.formatDateTime(call_end_datetime),
      reminder_datetime: this.formatDateTime(reminder_datetime)
    });

    if (this.callLogForm.valid) {
      const formData = new FormData();
      Object.keys(this.callLogForm.controls).forEach(key => {
        const control = this.callLogForm.get(key);
        formData.append(key, control.value);
      });
      if (this.type == 'edit') {
        formData.append('call_log_id', this.call_log_id);
        this.updateCallLog(formData);
      } else if (this.type == 'add') {
        formData.append('company_id', this.company_id);
        this.createCallLog(formData)
      }
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.callLogForm.controls).forEach(key => {
        this.callLogForm.get(key).markAsTouched();
      });
    }
  }
  createCallLog(formData) {
    // API call here
    this._CallsLogsService.addCallLogLead(formData, this.organizationId).subscribe(
      (response) => {
        if (response.success === true || response.success === 'true') {
          this.toastrMessage.showSuccess(response.message || "call log creatted successfully!")
          this.getCallLogList();
          this.modalRef.hide();
          this.cdr.detectChanges()
        } else {
          this.toastrMessage.showError(response.message)
        }
      },
      (err: any) => {
        this.toastrMessage.showError(err || err.errors)
      }
    );

  }
  updateCallLog(formData) {
    this._CallsLogsService.updateCallLogLead(formData, this.organizationId).subscribe(
      (response) => {
        if (response.success === true || response.success === 'true') {
          this.toastrMessage.showSuccess(response.message || "call log updated successfully!")
          this.getCallLogList();
          this.modalRef.hide();
          this.cdr.detectChanges()
        }

      },
      (err) => {
        console.log(err);
      }
    );
  }
  callLogDetail() {
    console.log("callLogDetail:", this.type, this.call_log_id, this.organizationId)
    this._CallsLogsService.viewCallLogListByID(this.call_log_id, this.organizationId).subscribe(
      (res: any) => {
        if (res.success === true || res.success === 'true') {
          const data = res.data;
          this.call_log_id = data.call_log_id,
            this.callLogForm.patchValue({
              call_log_id: data.call_log_id,
              call_type: data.call_type,
              call_status: data.call_status,
              call_result: data.call_result,
              notes: data.notes,
              contact_id: data.contact_id ? data.contact_id : '',
              call_start_datetime: data.call_start_datetime,
              call_end_datetime: data.call_end_datetime,
              is_reminder_set: data.is_reminder_set,
              reminder_datetime: data.reminder_datetime,
            });
          this.cdr.detectChanges();
        }
      },
      () => {
        this.toastrMessage.showError('Failed to load organization details');
      }
    );
  }
  openConfirmationDialogue(log) {
    console.log("log info:", log)
    this.modalRef = this.modalService.show(ConfirmationDialogComponent);
    this.modalRef.content.data = " this call log details";
    this.modalRef.content.action = "delete";
    this.modalRef.content.onClose.subscribe((confirm) => {
      if (confirm) {
        this._CallsLogsService
          .deleteCalllogLead(log.call_log_id, log.organization_id)
          .subscribe((response) => {
            if (response.success === true || response.success === "true") {
              this.getCallLogList();
              this.toastrMessage.showSuccess(response.message || "call log deleted successfully");
            } else {
              this.toastrMessage.showError(response.message)
            }
          });
      }
    });
  }
  resetCallLogForm() {
    this.callLogForm.reset();
    this.buildCallLogForm();
  }
  leadContactList: any;
  getContactList() {
    const payload = {
      company_id: this.company_id,
      page: 1,
      limit: 20,
      sort: "DESC",
      sort_field: "contact_id",
      fields: [
        {
          field: "string",
          operator: "contains or matches",
          value: "string"
        }
      ]
    }
    this._CallsLogsService.getContactListService(payload, this.organizationId).subscribe(
      (response) => {
        //  console.log("response for the contact :", response);
        if (response.success === true || response.success === 'true') {
          this.leadContactList = response.data;
          this.cdr.detectChanges()
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  //call log end
}
